itsoftApp.createModule("toggleTabs", function() {
    var module = this;

    var deletePopupHandler = function (el) {
        if (el.classList.contains("js-open-popup")) {
            el.classList.remove("js-open-popup");
            el.removeAttribute("data-popup-selector");
        }
    }

    var initTabToggle = function (tabs) {
        var tabs = tabs;
        var isContainingTabs = tabs.hasAttribute("data-containing-tabs");
        var toggler = tabs.querySelector(".js-tabs-list.js-toggle");
        var tabsItems;
        var currentActiveTab;
        var currentActiveTabs;
        var currentActiveContents;
        var clickedTab;
        var clickedTabName;
        if (isContainingTabs) {
            tabsItems = tabs.querySelectorAll("[data-parent-tabs] .js-tab-name");
            currentActiveTabs = tabs.querySelectorAll("[data-parent-tabs] .js-tab-name--active");
            currentActiveContents = tabs.querySelectorAll("[data-parent-content].js-tab-content--active");
        } else {
            tabsItems = tabs.querySelectorAll(".js-tab-name");
            currentActiveTabs = tabs.querySelectorAll(".js-tab-name--active");
            currentActiveContents = tabs.querySelectorAll(".js-tab-content--active");
        }

        var dataActiveSectionClass;
        var dataActiveSectionSelector;
        var sectionElement;
        var hash = location.hash;

        var goToHash = function (newHash, type) {
            var element;
            var contentElements;

            if (newHash) {
                newHash = newHash.replace(/^#/,'');
                var selector = "[data-tab-name='" + newHash + "']";
                var contentSelector = "[data-content-url='" + newHash + "']";
                element = tabs.querySelector(selector);
                contentElements = tabs.querySelectorAll(contentSelector);
            } else {
                element = tabsItems[0];
                var contentSelector = "[data-content-url='" + element.getAttribute("data-tab-name") + "']";
                contentElements = tabs.querySelectorAll(contentSelector);
            }

            if (element) {
                goToTab(element, contentElements, type);
            }
        }

        var goToTab = function (tab, contents, type) {
            var tabSelector;
            var toggleFlag = 0;
            deletePopupHandler(tab);
            clickedTab = tab;
            if (!clickedTab.classList.contains("js-tab-name--active")) {
                if (toggler && !toggleFlag) {
                    toggler.classList.toggle("js-toggle--active");
                    toggleFlag = 1;
                }
            }
            Array.prototype.forEach.call(currentActiveTabs, function (currentActiveTab) {
                currentActiveTab.classList.remove("js-tab-name--active");
            });
            Array.prototype.forEach.call(currentActiveContents, function (currentActiveContent) {
                currentActiveContent.classList.remove("js-tab-content--active");
            });
            if (dataActiveSectionClass) {
                sectionElement.classList.remove(dataActiveSectionClass);
            }
            if (clickedTab.hasAttribute("data-slider-name") && type !== "slider") {
                var slideIndex = clickedTab.getAttribute("data-slide-to");
                var sliderName = clickedTab.getAttribute("data-slider-name");
                if (itsoftApp.modules.slidersLibrary.sliders[sliderName]) {
                    itsoftApp.modules.slidersLibrary.sliders[sliderName].slideTo(+slideIndex);
                }
            }
            clickedTabName = clickedTab.getAttribute("data-tab-name");
            location.hash = clickedTabName
            currentActiveTabs = tabs.querySelectorAll("[data-tab-name='" + clickedTabName + "']");
            
            dataActiveSectionSelector = tab.getAttribute("data-section-selector");
            if (dataActiveSectionSelector) {
                sectionElement = document.querySelector(dataActiveSectionSelector);
            }

            dataActiveSectionClass = tab.getAttribute("data-section-class");

            if (dataActiveSectionClass) {
                sectionElement.classList.add(dataActiveSectionClass);
            }

            currentActiveContents = contents;
            Array.prototype.forEach.call(currentActiveTabs, function (currentActiveTab) {
                currentActiveTab.classList.add("js-tab-name--active");
            });
            Array.prototype.forEach.call(currentActiveContents, function (currentActiveContent) {
                currentActiveContent.classList.add("js-tab-content--active");
            });
        }

        var onTabClick = function (currentTab) {
            var tabSelector;
            if (currentTab.hasAttribute("data-tab-name")) {
                tabSelector = currentTab.getAttribute("data-tab-name");
                location.hash = tabSelector;
            }
            var tabsContents = tabs.querySelectorAll("[data-content-url='" + tabSelector + "']");
            if (!currentTab.closest(".js-disabled-tabs")) {
                goToTab(currentTab, tabsContents);
            }
        }

        var addTabClickListener = function (tab) {
            tab.addEventListener("click", function (evt) {
                evt.preventDefault();
                if (!evt.currentTarget.classList.contains("js-tab-name--active")) {
                    onTabClick(tab);
                }
            });
        }

        for (var i = 0; i < tabsItems.length; i++) {
            addTabClickListener(tabsItems[i]);
        }

        if (location.hash) {
            goToHash(location.hash, "hash");
        } else {
            deletePopupHandler(tabsItems[0]);
        }

        module.callback.goToHash = goToHash;
    }

    var initTabs = function (tabs) {
        if (tabs) {
            initTabToggle(tabs);
        }
    }

    module.callback = {};
    module.callback.init = initTabs;
})